import React from 'react'
import LinkCloud from '../ui/LinkCloud'
import s from './Introduction.less'

export const Introduction = ({ h1, h2, children }) => (
  <div className={s.root}>
    <h1 className={s.h1}>{h1}</h1>
    <h2 className={s.h2}>{h2}</h2>
    {children}
  </div>
)

export const IntroductionWithLinks = ({ h1, h2, links }) => (
  <Introduction h1={h1} h2={h2}>
    <LinkCloud links={links} />
  </Introduction>
)
